<template>
  <div :class="['ui-alert', `ui-alert--${type}`]">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  type?: 'info' | 'success' | 'error' | 'warning'
}>()
</script>

<style scoped>
.ui-alert {
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid;
  font: inherit;
}

.ui-alert--info {
  background: #e0f2fe;
  border-color: #0ea5e9;
  color: #0c4a6e;
}

.ui-alert--success {
  background: #dcfce7;
  border-color: #22c55e;
  color: #14532d;
}

.ui-alert--error {
  background: #fee2e2;
  border-color: #ef4444;
  color: #7f1d1d;
}

.ui-alert--warning {
  background: #fef3c7;
  border-color: #f59e0b;
  color: #78350f;
}
</style>
